/* pin.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 7 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M6.9,3.7c0.4-1.6-0.8-3.3-2.7-3.6S0.5,0.7,0.1,2.4c-0.3,1.4,0.4,2.7,1.8,3.3L0.2,16l3.5-9.9
                C5.2,6,6.6,5.1,6.9,3.7z"/>
            </svg>
         `,
    toggledIcon: `    
            <svg viewBox="0 0 14 16" preserveAspectRatio="none">
            <g>
                <polygon class="foreground-gl" points="4.9,16 7.1,8.9 6,8.1 	"/>
                <path class="foreground-gl" d="M13.7,10.3L7.9,6.1l0,0c1.3-0.1,2.5-1,2.8-2.4c0.4-1.6-0.7-3.3-2.3-3.6C6.8-0.3,5.2,0.7,4.8,2.4
                    c-0.1,0.5-0.1,1,0,1.5L1,1C0.7,0.8,0.3,0.9,0.1,1.1C-0.1,1.4,0,1.8,0.3,2L13,11.3c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.2
                    C14.1,10.9,14,10.5,13.7,10.3z"/>
            </g>
            </svg>
         `,
};
